module.exports = __webpack_public_path__ + "img/背景_u1.d44d1b1b.png";